(() => {
  if (window.semboniaCollectionSwatchesReady) return;
  window.semboniaCollectionSwatchesReady = true;
  const cache = new Map();
  const states = new WeakMap();
  const queue = [];
  let running = 0;
  let scheduled = false;
  let latestSelection;
  const productUrl = handle => `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}`;

  function load(handle) {
    if (!cache.has(handle)) {
      const promise = new Promise((resolve, reject) => {
        queue.push(async () => {
          try {
            const response = await fetch(`${productUrl(handle)}?section_id=sembonia-collection-swatches`);
            if (!response.ok) throw new Error('Swatch section unavailable');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const column = html.querySelector('.featured-product-swatches-column');
            if (!column) throw new Error('Swatch markup unavailable');
            resolve({ swatches: column.querySelector('.featured-product-swatches'), soldOut: column.dataset.productAvailable === 'false' });
          } catch (error) { reject(error); }
        });
      });
      cache.set(handle, promise);
      pump();
    }
    return cache.get(handle);
  }
  function pump() {
    while (running < 4 && queue.length) {
      running++;
      queue.shift()().finally(() => { running--; pump(); });
    }
  }
  function pinImage(card, state) {
    if (!state.image) return;
    card.querySelectorAll('.sq-sy-image').forEach(media => {
      let image = media.querySelector('.sembonia-selected-preview');
      if (!image) {
        image = document.createElement('img');
        image.className = 'primary item-image sembonia-selected-preview';
        media.append(image);
      }
      if (image.getAttribute('src') !== state.image) image.setAttribute('src', state.image);
      if (image.alt !== state.alt) image.alt = state.alt;
    });
    card.querySelectorAll('a.sparq-loop-product,a.sparq-title').forEach(link => {
      if (link.getAttribute('href') !== state.url) link.setAttribute('href', state.url);
    });
  }
  async function hydrate(card) {
    const handle = card.getAttribute('product-handle');
    if (!handle) return;
    let state = states.get(card);
    if (state?.handle !== handle) {
      card.querySelector('.sembonia-collection-swatches')?.remove();
      card.querySelectorAll('.sembonia-selected-preview').forEach(image => image.remove());
      card.querySelector('.sembonia-stock-badge')?.remove();
      delete card.dataset.semboniaSoldOut;
      delete card.dataset.semboniaSelectedSoldOut;
      card.querySelector('.sembonia-selected-stock-badge')?.remove();
      state = { handle };
      states.set(card, state);
    }
    pinImage(card, state);
    if (state.soldOut && !card.querySelector('.sembonia-stock-badge')) {
      const badge = document.createElement('span');
      badge.className = 'sembonia-stock-badge';
      badge.textContent = 'OUT OF STOCK';
      card.append(badge);
    }
    if (state.pending || state.failed || card.querySelector('.sembonia-collection-swatches')) return;
    state.pending = true;
    try {
      const source = await load(handle);
      if (!card.isConnected || states.get(card) !== state || card.getAttribute('product-handle') !== handle) return;
      const parent = card.querySelector('.sparq-bottom-items');
      if (!parent) return;
      state.soldOut = source.soldOut;
      card.dataset.semboniaSoldOut = String(source.soldOut);
      const row = source.swatches ? document.importNode(source.swatches, true) : document.createElement('div');
      row.classList.add('sembonia-collection-swatches');
      // Avoid duplicate tooltip IDs if a product is rendered twice.
      row.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
      row.querySelectorAll('[aria-describedby]').forEach(element => element.removeAttribute('aria-describedby'));
      parent.prepend(row);
    } catch (error) {
      state.failed = true; // Keep native swatches if the Shopify section cannot load.
      console.warn('[Sembonia] Could not load colour options for', handle);
    } finally { state.pending = false; }
  }
  function scan() {
    scheduled = false;
    document.querySelectorAll(':is(.page-collection, .page-search) .sparq-card[product-handle]').forEach(card => {
      const rect = card.getBoundingClientRect();
      if (rect.bottom >= -300 && rect.top <= innerHeight + 600) hydrate(card);
    });
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(scan); }
  }
  document.addEventListener('click', event => {
    const swatch = event.target.closest('.sembonia-collection-swatches a.featured-product-swatch');
    if (!swatch || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.stopImmediatePropagation();
    if (!swatch.dataset.swatchImage) return; // Native variant URL remains the fallback.
    event.preventDefault();
    const card = swatch.closest('.sparq-card');
    const state = states.get(card);
    if (!state) return;
    const request = {};
    latestSelection = request;
    state.request = request;
    document.querySelectorAll('.sembonia-collection-swatches [aria-current="true"]').forEach(item => item.removeAttribute('aria-current'));
    swatch.setAttribute('aria-current', 'true');
    const preview = new Image();
    preview.onload = () => {
      if (!card.isConnected || states.get(card) !== state || state.request !== request) return;
      state.image = swatch.dataset.swatchImage;
      state.alt = swatch.dataset.swatchAlt || swatch.getAttribute('aria-label') || '';
      state.url = swatch.href;
      pinImage(card, state);
      if (latestSelection === request) swatch.setAttribute('aria-current', 'true');
    };
    preview.onerror = () => {
      if (latestSelection === request && card.isConnected) window.location.assign(swatch.href);
    };
    preview.src = swatch.dataset.swatchImage;
  }, true);
  function start() {
    document.querySelectorAll(':is(.page-collection, .page-search) .sq-app').forEach(root => {
      new MutationObserver(schedule).observe(root, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['product-handle', 'src', 'srcset']
      });
    });
    schedule();
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
